import { render } from "./ServerCard.vue?vue&type=template&id=366f9fdf&scoped=true"
import script from "./ServerCard.vue?vue&type=script&lang=js"
export * from "./ServerCard.vue?vue&type=script&lang=js"

import "./ServerCard.vue?vue&type=style&index=0&id=366f9fdf&lang=scss&scoped=true"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366f9fdf"]])

export default __exports__